import React, { useEffect, useState } from 'react';
import { Alert, TextField, Button, Box, Typography, Link, Paper } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import ReCAPTCHA from 'react-google-recaptcha';

function LoginPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [captchaToken, setCaptchaToken] = useState(null);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [showRegister, setShowRegister] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      // Optionally, verify the token by sending it to the server
      axios.get('https://api.pathvizor.com/verify-token', { headers: { Authorization: `Bearer ${token}` } })
        .then(() => {
          // If token is valid, redirect to the dashboard
          window.location.href = '/';
        })
        .catch(() => {
          // If token is invalid, clear it from local storage
          localStorage.removeItem('token');
        });
    }
  }, []);

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    setMessage('');
    // if (!captchaToken) {
    //     setError('Please complete the CAPTCHA');
    //     return;
    // }

    try {
      const response = await axios.post('https://api.pathvizor.com/login', { email, password });

      // Store the token in localStorage
      localStorage.setItem('token', response.data.token);

      setMessage(response.data.message);
      window.location.href = '/dashboard';
    } catch (error) {
      if (error.response) {
        setError(error.response.data.error);
      } else {
        setError('An unexpected error occurred.');
      }
    }
  };

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', backgroundColor: '#f5f5f5' }}>
      <Paper sx={{ width: '100%', maxWidth: 400, padding: 3, borderRadius: 2, boxShadow: 3 }}>
        <Typography variant="h4" align="center" color="primary" gutterBottom>
        Pathvizor Login
        </Typography>
        {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
        <TextField
          fullWidth
          label="Email"
          variant="outlined"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          sx={{ marginBottom: 2 }}
        />
        <TextField
          fullWidth
          label="Password"
          variant="outlined"
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          sx={{ marginBottom: 2 }}
        />
        <Button variant="contained" color="primary" fullWidth onClick={handleLogin} sx={{ marginBottom: 2 }}>
          Login
        </Button>
        <Box sx={{ textAlign: 'center' }}>
          <Link href="/register" sx={{ color: '#D6BF87', fontWeight: 'bold' }}>Don't have an account? Register</Link>
        </Box>
      </Paper>
    </Box>
  );
}

export default LoginPage;
